export function scrollToBlock(blockId: string) {
    const block = document.getElementById(blockId) as HTMLElement;
    //This is height of header
    const yOffset = -80;
    const y = block.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({top: y, behavior: 'smooth'});
}